module.exports = __webpack_public_path__ + "media/images/favicon/favicon-c8fe56df693db44191b21356e43580ee.ico";